    <div class="booking-list">
      <div class="page-header">
        <h1 class="page-title">Бронирования</h1>
        <button mat-mini-fab color="primary" routerLink="/bookings/new" aria-label="Добавить">
          <mat-icon>add</mat-icon>
        </button>
      </div>

      <mat-form-field appearance="outline" class="search-field" subscriptSizing="dynamic">
        <mat-icon matPrefix>search</mat-icon>
        <input matInput type="text" [ngModel]="searchQuery" (ngModelChange)="onSearchInput($event)"
               placeholder="Поиск по телефону или названию авто" aria-label="Поиск бронирований">
        <button *ngIf="searchQuery" matSuffix mat-icon-button type="button"
                aria-label="Очистить" (click)="clearSearch()">
          <mat-icon>close</mat-icon>
        </button>
      </mat-form-field>

      <mat-tab-group [selectedIndex]="selectedTab" (selectedIndexChange)="onTabChange($event)"
                     animationDuration="0ms" class="status-tabs">
        <mat-tab label="Все">
          <div class="tab-content">
            <ng-container *ngTemplateOutlet="tabBody; context: tabs[0]"></ng-container>
          </div>
        </mat-tab>
        <mat-tab label="Новые">
          <div class="tab-content">
            <ng-container *ngTemplateOutlet="tabBody; context: tabs[1]"></ng-container>
          </div>
        </mat-tab>
        <mat-tab label="Подтверждённые">
          <div class="tab-content">
            <ng-container *ngTemplateOutlet="tabBody; context: tabs[2]"></ng-container>
          </div>
        </mat-tab>
      </mat-tab-group>
    </div>

    <ng-template #tabBody let-bookings="bookings" let-loading="loading"
                 let-page="page" let-pageSize="pageSize" let-totalPages="totalPages"
                 let-totalItems="totalItems">
      <div *ngIf="loading" class="loading-container">
        <mat-spinner diameter="40"></mat-spinner>
      </div>
      <div *ngIf="!loading && bookings.length > 0" class="bookings-list">
        <app-booking-card *ngFor="let b of bookings" [booking]="b"></app-booking-card>
      </div>
      <div *ngIf="!loading && bookings.length === 0" class="empty-state">
        <mat-icon>event_busy</mat-icon>
        <ng-container *ngIf="searchQuery; else noResults">
          <p>Ничего не найдено по запросу «{{ searchQuery }}»</p>
        </ng-container>
        <ng-template #noResults>
          <p>Нет бронирований</p>
        </ng-template>
      </div>
      <app-pagination *ngIf="!loading && totalItems > 0"
        [page]="page"
        [totalPages]="totalPages"
        [pageSize]="pageSize"
        [totalItems]="totalItems"
        (pageChange)="onPageChange($event, selectedTab)">
      </app-pagination>
    </ng-template>
